module.exports = __webpack_public_path__ + "img/promotion-phone.fe4bef24.png";